import { render, staticRenderFns } from "./promptTableTwo.vue?vue&type=template&id=1003c3d2&scoped=true"
import script from "./promptTableTwo.vue?vue&type=script&lang=js"
export * from "./promptTableTwo.vue?vue&type=script&lang=js"
import style0 from "./promptTableTwo.vue?vue&type=style&index=0&id=1003c3d2&prod&lang=scss&scoped=true"
import style1 from "./promptTableTwo.vue?vue&type=style&index=1&id=1003c3d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1003c3d2",
  null
  
)

export default component.exports